'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var REWARD_COUNT = 'reward:count';
var CLEAR_REWARD_COUNT = 'clear:reward-count';

exports.CLEAR_REWARD_COUNT = CLEAR_REWARD_COUNT;
exports.REWARD_COUNT = REWARD_COUNT;
